"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _loggedinMeterReadingActions = require("../actions/meterReading/loggedinMeterReadingActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  loading: true,
  apiError: false,
  noMeters: false,
  openMeter: '',
  metersWithCategory: [],
  metersWithoutCategory: [],
  metersWithLockedCategory: [],
  savedMeters: []
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _loggedinMeterReadingActions.MeterReadingActions.LOAD_ALL_METERS:
      {
        var metersWithCategory = action.data.devices.filter(function (device) {
          return device.readingStatus === 'WITH_OPEN_READING_ORDERS';
        });
        var metersWithoutCategory = action.data.devices.filter(function (device) {
          return device.readingStatus === 'WITHOUT_OPEN_READING_ORDERS';
        });
        var metersWithLockedCategory = action.data.devices.filter(function (device) {
          return device.readingStatus === 'LOCKED';
        });
        var selectedMeterSerialNumber = (metersWithCategory === null || metersWithCategory === void 0 ? void 0 : metersWithCategory.length) > 0 ? metersWithCategory[0].serialNumber : '';
        return _objectSpread(_objectSpread({}, state), {}, {
          noMeters: action.data.devices.length === 0,
          loading: false,
          metersWithCategory: metersWithCategory,
          metersWithoutCategory: metersWithoutCategory,
          metersWithLockedCategory: metersWithLockedCategory,
          openMeter: selectedMeterSerialNumber,
          savedMeters: []
        });
      }
    case _loggedinMeterReadingActions.MeterReadingActions.LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: action.loading
        });
      }
    case _loggedinMeterReadingActions.MeterReadingActions.MARK_METER_SAVED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          savedMeters: [].concat((0, _toConsumableArray2.default)(state.savedMeters), [action.serialNumber])
        });
      }
    case _loggedinMeterReadingActions.MeterReadingActions.OPEN_METER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          openMeter: action.serialNumber
        });
      }
    case _loggedinMeterReadingActions.MeterReadingActions.SET_API_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          apiError: action.apiError,
          loading: action.loading
        });
      }
    default:
      return state;
  }
}